import {
  BleCodec,
  BleDeviceProtocol,
  BleDeviceProtocolBeginSeal,
  BleDeviceProtocolOperation,
  BleSend,
} from "@hybird/device/protocol/ble";
import {config, DeviceType} from "@hybird/device/config";
import {DeviceBeginSealType, DeviceEvent} from "@hybird/core/device/protocol";
import service from "@hybird/core/request";
import url from "@hybird/device/request";
import request from "@hybird/device/request";
import {Buffer} from "buffer";
import {ADeviceProvide} from "@hybird/device/terminal/a";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";
import moment from "moment";
import md5 from "md5";

class BleSendV2 extends BleSend {

  async cancelOperation({type, success, complete, message, fail, timeout} = {}) {
    // if (type === 1 && this.deviceProtocol.deviceInfo.leftTimes <= 0 && this.deviceProtocol.deviceInfo.remote !== DeviceBeginSealType.remote) {
    //   return;
    // }
    //
    // const noReply = type === 1 && this.deviceProtocol.deviceInfo.leftTimes <= 0 && this.deviceProtocol.deviceInfo.remote === DeviceBeginSealType.remote

    const noReply = true;

    return this.service(this.deviceProtocol.serviceName.CANCEL_OPERATION, [type], {
      success, complete, message, fail, timeout, noReply: type === 3 || noReply
    })
  }
}

class BleV2DeviceProtocol extends BleDeviceProtocol {

  _version = 2;

  get version() {
    return this._version;
  }

  set version(version) {
    this._version = version;
  }

  constructor(deviceProvide, deviceInfo, deviceProtocolOption, codec = BleSendV2) {
    super(deviceProvide, deviceInfo, deviceProtocolOption, codec);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new BleV2DeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new BleV2DeviceProtocolOperation(this.deviceInfo, this);
  }

  async getBluetoothType() {
    // let bluetoothType = this.deviceInfo.bluetoothType;
    //
    // if (!bluetoothType) {
    //   const monitoringConnect = await service.get(request.monitoringConnect.format(this.deviceInfo.number))
    //
    //   bluetoothType = this.deviceInfo.bluetoothType = monitoringConnect.data?.bluetoothType
    // }
    //
    // return bluetoothType;
    return 2;
  }

  async canConnect() {
    const bluetoothType = await this.getBluetoothType();
    return bluetoothType === 2;
  }

  get serviceName() {
    return {
      DEVICE_MATCH: "DEVICEMATCHV2",
      MAINTAIN: "MAINTAINV2",
      USER_LOGOUT: "USERLOGOUTV2",
      REMOTE_LOCK: "REMOTELOCKV2",
      STOP_STAMP: "STOPSTAMPV2",
      STOP_REPLACE: "STOPREPLACEV2",
      STOP_AINK: "STOPAINKV2",
      EXAMINE_RESULT: "EXAMINERESULTV2",
      FINGERPRINT: "FIGRESULTV2",
      START_STAMP: "STARTSTAMPV2",
      REPLY_STAMP: "REPLYSTAMPV2",
      POST_DOCUMENT_FILEID: "POSTDOCUMENTFILEIDV2",
      CANCEL_OPERATION: "CANCELOPERATIONV2",
      INKING: "INKINGV2",
      ENVINFO: "ENVINFOV2",
      AINK: "AINKV2",
      AINK_END: "AINKENDV2",
      START_REPLACE: "STARTREPLACEV2",
      END_REPLACE: "ENDREPLACEV2",
      ENV_CHANGE: "ENVCHANGEV2",
      CONNECT_CHANGE: "USBMODEV2",


      FINGERPRINTTYPE: "FINGERPRINTTYPEV2",
      FINGERPRINTVERIFY: "FINGERPRINTVERIFYV2",
      FINGERPRINTEND: "FINGERPRINTENDV2",
      WIFI_LIST: "WIFILISTV2",
      WIFI_SETTING: "WIFISETTINGV2",

      //v2
      ACTION_END: "ACTIONENDV2",
      CLICK: "CLICKPOSTV2",
      CLICK_RESULT: "CLICKRESULTV2",

      SINGING: "SINGINGV2",
      LOCK: "LOCKV2",
      MOVE: "MOVEV2",
      STICK_OUT_STAMP: "SEALSTRETCHOUTV2",
      SEAL_STRETCH: "SEALSTRETCHV2",
      FIGSYNC: "FIGSYNCV2",
      FEATURE_PACKET: "FEATUREPACKETV2",

      UPGRADE: "UPGRADEV2",
      UPGRADE_LOCAL: "UPGRADELOCALV2",
      UPGRADE_PACKET: "UPGRADEPACKETV2",
      UPGRADE_PROGRESS: "UPGRADEPROGRESSV2",

      FIG: "FINGERPRINTENTERINGV2",

      //v4
      DEVICEINFOGET: "DEVICEINFOGETV2",
      DEVICEINFOSET: "DEVICEINFOSETV2",

      PRIVILEGEDATA: "PRIVILEGEDATAV2",
      PRIVILEGEDATARESULT: "PRIVILEGEDATARESULTV2",
      USERLOGOUT: "USERLOGOUTV2",
      EXCESSSEAL: "EXCESSSEALV2",
    }
  }

  get codec() {
    return BleV2Codec.codec;
  }

  info({success, complete, message, fail, timeout} = {}) {
    return this.service(this.serviceName.DEVICEINFOGET, [], {
      success, complete, message, fail, timeout
    }).then(({params}) => {
      if (params.length < 4) {
        throw WebError.code(deviceError.DEVICE_INITIALIZE);
      }
      this.deviceInfo.api = params[8]
      this.deviceInfo.iot = params[9]
      //0：均支持（非smart使用）1:4G（主机）2:adb（从机）version:7
      if (+this.version >= 7) {
        this.deviceInfo.usbMode = params[10]
      }

      return {
        number: params[1],
        version: params[2],
        type: params[3],
        id: params[4],
        status: params[5],
        api: params[8],
        iot: params[9],
      }
    })
  }

  async connect({success, complete, message, fail, timeout = 30, config = {}} = {}) {
    const bluetoothType = await this.getBluetoothType();

    if (this.deviceInfo.modelType === DeviceType.aplus || this.deviceInfo.modelType === DeviceType.a_smart) {
      if (bluetoothType === 2 && this.deviceInfo.wifi != 0) {
        config.blue = {
          serviceUUIDs: ["0000180a-0000-1000-8000-00805f9b34fb"],
          characteristicUUIDs: {
            "00009999-0000-1000-8000-00805f9b34fb": "write",
            "dfd4416e-1810-47f7-8248-eb8be3dc47f9": "read"
          }
        }
      } else {
        config.blue = {
          serviceUUIDs: config.blue.a.serviceUUIDs,
          characteristicUUIDs: config.blue.a.characteristicUUIDs
        }
      }
    }

    config.blue.mac = this.deviceInfo.bleMac;

    return super.connect({success, complete, message, fail, timeout, config})
  }

  async _connect({success, sync, complete, message, fail, timeout = 20, config} = {}) {
    this._createMqttSend();

    this.emit(DeviceEvent.BEFORE_USER_LOGIN);

    this.deviceConnectProvide.codec = this.codec;

    let getSign;
    if (this.deviceInfo.deviceSecret) {
      const timestamp = new Date().getTime();
      const signStr = `${this.deviceInfo.deviceSecret}&${this.deviceInfo.staffId}&${this.deviceInfo.userName}`
      const sign = md5(signStr);
      console.log(sign);

      getSign = {
        userName: this.deviceInfo.userName,
        staffId: this.deviceInfo.staffId,
        timestamp,
        sign
      }
    } else {
      getSign = await this._userLoginSend(timeout)
      if (!getSign?.sign) {
        getSign = await this._getSignSend(timeout);
        let time = getSign.timestamp.toString();
        if (time.length > 10) {
          getSign.timestamp = Number(time.substring(0, 10))
        }
      }
    }

    const data = await this.service(this.serviceName.DEVICE_MATCH, [
      getSign.userName,
      getSign.staffId,
      getSign.timestamp,
      getSign.sign,
      3,
      getSign.workbenchSn
    ], {
      success, complete, message, fail, timeout
    }).catch(e => {
      if (deviceError.isError(e, deviceError.PUBLISH_AND_RESULT_NOT_SUCCESS)) {
        if (e.data.code === 100004) {
          throw WebError.code(deviceError.DEVICE_USE_NOT_CONNECT, {error: e});
        }
      }

      throw e;
    });

    if (data.params.length > 4) {
      this.deviceMatch = {
        userName: data.params[1],
        staffId: data.params[2],
        sdkVersion: data.params[3],
        energyType: parseInt(data.params[4]),
        energy: parseInt(data.params[5]),
        bleMac: data.params[6],
        plank: data.params[7],
        systemVersion: data.params[8],
        version: data.params[9],
        number: this.deviceInfo.number
      }

      await this._propertySyncSend(this.deviceMatch);
    }

    if (data.params[3]) {
      this._version = parseInt(data.params[3]);
    } else {
      this._version = 2;
    }

    if (this.version >= 4) {
      await this.info();
    }

    this.emit(DeviceEvent.USER_LOGIN);
  }

  async _disconnect({type, logout, success, complete, message, fail, timeout} = {}) {
    try {
      await this._userLogoutSend();

      if (this.deviceConnectProvide.connected) {
        await this.endSeal({force: true, type, logout});

        if (type !== 3) {
          await this.service(this.serviceName.USERLOGOUT, [], {
            success, complete, message, fail, timeout
          })
        }
      }

      this.deviceMatch = null;
      await success?.call(this);
      complete?.call(this);
    } catch (e) {
      complete?.call(this, null, e);
    } finally {
      await this.send.unsubscribe();
    }
  }

  async figsync({type, position, auth, featureString, success, complete, message, fail, timeout} = {}) {
    await this.send.service(this.serviceName.FIGSYNC, [type, position, auth], {
      success,
      complete,
      message,
      fail,
      timeout
    });

    if (type === 1) {
      const buffer = Buffer.from(featureString);

      await this.sendPackage({
        size: 384,
        buffer, fn: async (i, data, size) => {
          if (i > 8) {
            return;
          }

          await this.send.service(this.serviceName.FEATURE_PACKET, [i, data.toString()], {
            success,
            complete,
            message,
            fail,
            timeout
          })
        }
      })
    }

    await this._fingerprintImportStateSend({type, position, auth, featureString})
  }

  async _precord() {
    return this._precordSize(1);
  }

  async _precordSize(size) {
    if (this.version < 4) {
      return super._precord();
    }

    let timeoutCallback;
    let dataList = [];
    let totalSize = 0;
    let syncLength = 0;
    let timeout = 20;

    const oldVersion = this.version < 6
    const PRIVILEGEDATA = oldVersion ? this.serviceName.PRIVILEGEDATA : this.serviceName.PRIVILEGEDATA.replace("PRIVILEGE", "P");
    const PRIVILEGEDATARESULT = oldVersion ? this.serviceName.PRIVILEGEDATARESULT : this.serviceName.PRIVILEGEDATARESULT.replace("PRIVILEGE", "P");

    const getDate = (size) => {
      let length = 0;

      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        let pageIndex = 0;
        let pageSize = 0;
        const cacheTopic = {}

        // timeoutCallback = setTimeout(() => {
        //   reject(WebError.code(deviceError.PRECORD_TIMEOUT));
        // }, timeout * 1000);


        await this.send.listen(PRIVILEGEDATA, {
          cacheTopic: cacheTopic,
          message: async (message) => {
            try {
              const params = message.params;

              const currTotalSize = parseInt(params[1]);
              pageIndex = parseInt(params[2]);
              pageSize = parseInt(params[3]);

              if (totalSize < currTotalSize) {
                totalSize = currTotalSize;
              }

              // dataList.push(...data);
              if (pageSize > 0) {
                try {
                  const data = JSON.parse(params[4]);
                  const dataWithNumber = data.map(item => {
                    if (!oldVersion) {
                      return {
                        sealId: item["a"],
                        position: item["b"],
                        sealTime: item["c"],
                        documentId: item["d"],
                        leftTimes: item["e"],
                        staffId: item["f"],
                        coverId: item["g"],
                        operationId: item["h"],
                        specialTag: item["i"]
                      }
                    }

                    return item;
                  }).map(item => ({
                    ...item,
                    number: this.deviceInfo.number
                  }));

                  length += dataWithNumber.length;
                  syncLength += length;

                  //先同步一半
                  this.emit(DeviceEvent.SYNC_STATUS, {
                    progress: ((totalSize === 0 ? 1 : syncLength / totalSize) - length / 2) * 99 / 100,
                    type: 2,
                    data: dataWithNumber
                  });

                  await this._documentPrivilegeUploadSend(dataWithNumber);
                  await this.send.service(PRIVILEGEDATARESULT, [1]);

                  //上传完成后同步所有
                  this.emit(DeviceEvent.SYNC_STATUS, {
                    progress: (totalSize === 0 ? 1 : syncLength / totalSize) * 99 / 100,
                    type: 2,
                    data: dataWithNumber
                  });
                } catch (e) {
                  await this.send.service(PRIVILEGEDATARESULT, [2]);
                  throw e;
                }
              } else {
                //拉取过多时, 提前结束
                resolve(true);
                return;
              }


              await this.send.unsubscribe(cacheTopic);
              resolve(totalSize <= syncLength);
              dataList = []

              //清理定时器
              clearTimeout(timeoutCallback);
            } catch (e) {
              await this.send.unsubscribe(cacheTopic);
              reject(WebError.error(e, deviceError.PRECORD_ERROR))
            }
          }
        }).catch(e => {
          reject(WebError.error(e, deviceError.PRECORD_ERROR))
        });
      });
    }
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const data = getDate(size);
      await this.send.service(PRIVILEGEDATA, [size], {noReply: true});

      const done = await data;

      if (done) {
        break;
      }
    }
    this.emit(DeviceEvent.SYNC_STATUS, {
      progress: 1,
      type: 2,
      data: dataList
    });
  }

  _setDeviceConfig({config, success, complete, message, fail, timeout}) {
    if (this.version > 3) {
      return this.send.service(
              this.serviceName.DEVICEINFOSET,
              [
                config.offTime,
                config.sleepTime,
                config.voice,
                config.sealPattern,
                config.useWifi,
                config.useBluetooth,
                config.useMobileNetwork,
                config.gyroParameter,
                config.wifiPriority,
                config.sealId,
                config.sealType,
                this.connectType === 1 ? config?.sealName?.substring(0, 100) : config.sealName,
                config.remoteWake,
                config.needConvertVideo,
                config.lianXuDeduct,
              ],
              {
                success,
                complete,
                message,
                fail,
                timeout
              }
      )
    }
  }
}

class BleV2DeviceProtocolBeginSeal extends BleDeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }

  async _beginSeal({authentication = true, success, complete, message, fail, timeout} = {}) {
    if (this.deviceProtocol.version >= 3) {
      return this.send.service(this.deviceProtocol.serviceName.START_STAMP,
              [
                this.option.documentId,
                this.option.sealId,
                this.option.leftTimes,
                this.option.position ? this.option.position.map(s => s.toString().padLeft(3, "0")).join("") : "000",
                this.option.remote !== 2 && this.option.sealAuthentication === 1 ? 4 : this.option.remote,
                authentication ? this.option.authentication : 2,
                this.option.pictureType,
                this.option.infrared,
                this.option.hasCover ? this.option.coverId : 0,
                this.option.businessKey,
                this.deviceInfo.deviceSealAuthentication,
                this.deviceInfo.operationId,
                this.deviceInfo.equipmentRecVideoAllType,
                this.deviceInfo.everyType,
                this.deviceInfo.riskType,
                this.deviceInfo.timeDivision,
                this.deviceInfo.parseBeforeStamping,
                this.deviceInfo.snapIntervalTx,
              ], {
                success, complete, message, fail, timeout
              });
    } else {
      return this.send.service(this.deviceProtocol.serviceName.START_STAMP,
              [
                this.option.documentId,
                this.option.sealId,
                this.option.leftTimes,
                this.option.position ? this.option.position.map(s => s.toString().padLeft(3, "0")).join("") : "000",
                this.option.remote !== 2 && this.option.sealAuthentication === 1 ? 4 : this.option.remote,
                authentication ? this.option.authentication : 2,
                this.option.pictureType,
                this.option.infrared,
                this.option.hasCover ? this.option.coverId : 0,
                this.option.businessKey,
                this.deviceInfo.operationId,
              ], {
                success, complete, message, fail, timeout
              });
    }
  }

  async _clickResult({status, desc, success, complete, message, fail, timeout}) {
    return this.send.service(this.deviceProtocol.serviceName.CLICK_RESULT,
            [
              status, desc
            ], {
              success, complete, message, fail, timeout
            });
  }

  async _examineResult(documentRemoteId, state, {mode, type, success, complete, message, fail, timeout} = {}) {
    if (this.deviceInfo.modelType === ADeviceProvide.modelType || this.deviceInfo.remote === DeviceBeginSealType.remote) {
      return this.send.service(this.deviceProtocol.serviceName.EXAMINE_RESULT, [documentRemoteId, state], {
        success, complete, message, fail, timeout, noReply: state !== 1
      });
    } else {
      return this.send.service(this.deviceProtocol.serviceName.EXAMINE_RESULT, [this.deviceInfo.documentId, state, mode, type], {
        success, complete, message, fail, timeout, noReply: state !== 1
      });
    }
  }

  async _onSealEvent({success, complete, message, fail, timeout} = {}) {
    try {
      await this.send.listen(this.deviceProtocol.serviceName.CLICK, {
        message: (data, reply) => {
          this.deviceProtocol.emit(DeviceEvent.SEAL_STATUS, {status: 1});
          message?.call(this, data);
        }
      });

      await this.send.listen(this.deviceProtocol.serviceName.ACTION_END, {
        message: (data, reply) => {
          this.deviceProtocol.emit(DeviceEvent.SEAL_STATUS, {status: 3});
          message?.call(this, data);

          if ((this._mode === 1 || this.option.remote === DeviceBeginSealType.remote) && this._context.isExamine) {
            this.contextReset(true);
          }
        }
      });


      await this.send.listen(this.deviceProtocol.serviceName.EXCESSSEAL, {
        message: (data) => {
          const params = {
            businessType: 52,
            documentId: this.deviceInfo.documentId,
            sealId: this.deviceInfo.sealId,
            staffId: this.deviceInfo.staffId,
            lon: this.deviceProtocol.config.gps.lon,
            lat: this.deviceProtocol.config.gps.lat,
            warningTime: data.params[4] || moment().format("YYYY-MM-DD HH:mm:ss")
          }

          this._stampDataWarningSend(params);
        }
      });

      await this.send.listen(this.deviceProtocol.serviceName.REPLY_STAMP, {
        message: async (msg, reply) => {
          try {
            console.log("监听到盖印数据", msg);
            const data = {
              // documentId~position~sealId~leftTimes~locateMode~gps~sealTime
              documentId: parseInt(msg.params[1]),
              position: msg.params[2],
              sealId: parseInt(msg.params[3]),
              leftTimes: parseInt(msg.params[4]),
              sealTime: msg.params[5],
              staffId: parseInt(msg.params[6]),
              coverId: msg.params[7],
              stampId: msg.params[8]
            };

            this.option.leftTimes = data.leftTimes;
            this.deviceInfo.leftTimes = data.leftTimes;

            const result = await this._stampDataUploadSend(data);

            this.deviceProtocol.emit(DeviceEvent.SEAL_STATUS, {status: 2});
            this.deviceProtocol.emit(DeviceEvent.DOCUMENT_STATE_UPLOADING, data);

            if (result?.data?.documentFileId) {
              this.send.service(this.deviceProtocol.serviceName.POST_DOCUMENT_FILEID, [result.data.documentFileId, data.stampId]).catch(e => {
                console.warn("传输documentFileId失败");
              });
            }

            message?.call(this, data);
          } catch (e) {
            // reply([], {error: e});
          }
        }, fail, timeout
      });

      this.mqttSend?.listen("document_file_uploadMsg_event", false, {
        message: data => {
          console.log("监听到盖印数据", data);

          if (data.params.documentId == this.deviceInfo.documentId && data.params.staffId == this.deviceInfo.staffId) {
            if (this.option.currStartLeftTimes < data.params.leftTimes) {
              console.warn(`上报离线图片数据, 开始: ${this.option.currStartLeftTimes}, 现数据：${this.deviceInfo.leftTimes}, 原数据：${data.params.leftTimes}`)
              return;
            }
            this.deviceProtocol.emit(DeviceEvent.DOCUMENT_FILE_UPLOAD, data);
          }
        }
      });

      await success?.call(this);
      complete?.call(this);
    } catch (e) {
      complete?.call(this, null, e);
      throw WebError.code(deviceError.SYSTEM_ERROR, {
        error: e
      });
    }
  }

  async _sealStretch({out = true, urgent, remoteLock = 2, success, complete, message, fail, timeout} = {}) {
    if (out) {
      return this.send.service(this.deviceProtocol.serviceName.STICK_OUT_STAMP, [remoteLock], {
        success, complete, message, fail, timeout, noReply: true
      })
    } else {
      return this.send.service(this.deviceProtocol.serviceName.SEAL_STRETCH, [remoteLock], {
        success, complete, message, fail, timeout, noReply: true
      })
    }
  }
}

class BleV2DeviceProtocolOperation extends BleDeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }

  async _singing({state, success, complete, message, fail, timeout} = {}) {
    return this.send.service(this.deviceProtocol.serviceName.SINGING, [state], {
      success,
      complete,
      message,
      fail,
      timeout
    });
  }

  async firmwareUpgrade({type = 1, data, localCallback, path, success, complete, message, fail, timeout} = {}) {
    return this._firmwareUpgrade({type, data, localCallback, path, success, complete, message, fail, timeout});
  }

  async _fingerprintRemove({staffId, auth, type, success, complete, message, fail, timeout} = {}) {
    if (type === 2) {
      const result = await service.getFrom(request.fingerprintRemoveBle, {
        staffId: staffId,
        number: this.deviceInfo.number
      });

      for (const i in result.data) {
        const position = result.data[i];
        await this.send.service(this.deviceProtocol.serviceName.FIGSYNC, [2, result.data[i], 0], {
          noReply: true,
          success,
          complete,
          message,
          fail,
          timeout
        });

        await this._fingerprintRemoveFinishSend({staffId, type, position});
      }

      return {
        type,
        position: result.data
      }
    } else {
      await this.send.service(this.deviceProtocol.serviceName.FIGSYNC, [3, 0, 0], {
        noReply: true,
        success,
        complete,
        message,
        fail,
        timeout
      });

      await this._fingerprintClearFinishSend({staffId, type});
    }

    return {
      type
    }
  }

  async _firmwareUpgrade({
                           type = 1,
                           data,
                           localCallback,
                           path = data?.path,
                           success,
                           complete,
                           message,
                           fail,
                           timeout
                         }) {
    const progress = {
      step: 1, progress: 0
    }

    if (type === 1) {
      if (this.deviceProtocol.version < 4) {
        throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT_CHANGE, {
          data: {
            curr: 1, change: 2
          }
        })
      }
    } else if (type === 2) {
      if (this.deviceProtocol.version < 3) {
        throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT, {
          msg: "当前版本不支持镜像升级, 请升级固件"
        })
      }
    }

    try {
      const time = 100;
      const totalTime = 5000;

      this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, progress);

      const index = setInterval(() => {
        if (progress.step >= 3 || progress.step < 0) {
          clearInterval(index);
        }

        if (progress.progress < 100) {
          progress.progress += 100 / (totalTime / time)
          this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, progress);
        }
      }, time)

      await new Promise((resolve, reject) => {
        if (type === 1) {
          this.send.listen(this.deviceProtocol.serviceName.UPGRADE_PROGRESS, {
            message: ({params}) => {
              const step = parseInt(params[1]);

              progress.step = step;
              progress.progress = 0;
              progress.desc = params[2];

              if (step < 0) {
                reject(WebError.code(deviceError.UPGRADE_WAIT_SUCCESS_TIMEOUT));
              } else if (step === 1) {
                this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: 1, progress: 100});
              } else if (step === 2) {
                this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: 2, progress: 100});
                resolve();
              }
            }
          })
        }

        if (data) {
          let send = async (serviceName, params) => {
            return this.send.service(serviceName, params, {noReply: (type === 1 && this.deviceProtocol.version < 5) || params[5] === 2})
                    .then(result => {
                      if (type === 2) {
                        if (params[5] === 2 || params[5] === 3) {
                          console.log("传输过程中, 无返回参数")
                        } else if (result.code !== 1) {
                          switch (result.code) {
                            case 2:
                              throw WebError.code(deviceError.FIRMWARE_UPGRADE_ERROR, {msg: "发起镜像升级失败，内存不足"})
                            case 3:
                              throw WebError.code(deviceError.FIRMWARE_UPGRADE_ERROR, {msg: "发起镜像升级失败，请连接wifi后使用"})
                            case 4:
                              throw WebError.code(deviceError.FIRMWARE_UPGRADE_ERROR, {msg: "发起镜像升级失败，电池需保持在80%以上"})
                          }
                        } else {
                          resolve();
                          service.getFrom(url.firmwareUpgradeSync, {
                            number: this.deviceInfo.number,
                            staffId: this.deviceInfo.staffId
                          })
                        }
                      }
                    })
                    .catch(e => {
                      reject(WebError.error(e, deviceError.UPGRADE_WAIT_SUCCESS_TIMEOUT));
                    });
          }
          let serviceName = this.deviceProtocol.serviceName.UPGRADE;

          if (path) {
            //取消定时器
            clearInterval(index);

            let params = [path, data.sign, data.edition, data.size, type]
            serviceName = this.deviceProtocol.serviceName.UPGRADE_LOCAL;
            params[5] = 1;

            // 开始下载
            send(serviceName, params).then(async data => {
              await localCallback(params[5]);

              // 下载完成, 传输中
              params[5] = 2;
              return send(serviceName, params);
            }).then(async data => {
              await localCallback(params[5]);

              // 开始升级
              params[5] = 3;
              return send(serviceName, params);
            }).catch(async e => {
              console.warn("升级失败", e);

              // 开始失败
              params[5] = -1;
              await send(serviceName, params);

              throw e;
            });
          } else {
            let params = [data.fullFirmwareLink, data.sign, data.edition, data.size, type]
            send(serviceName, params);
          }
        }
      })
    } catch (e) {
      this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {
        step: -1, progress: 0, desc: "升级失败"
      });
      throw e;
    }


    let clearFn;
    let timeoutIndex;
    let clearBle = {};
    let clear = {}

    return {
      autoReconnect: false,
      reconnect: () => {
        if (type === 1) {
          return new Promise((resolve, reject) => {
            //等待正常协议回调
            const listenProperty = msg => {
              if (msg.version === data.edition) {
                resolve();
              }
            };

            clearFn = () => {
              if (timeoutIndex) {
                clearTimeout(timeoutIndex);
              }
              this.mqttSend?.unsubscribe(clear);
              this.send.unsubscribe(clearBle);
              this.deviceProtocol.removeListener(DeviceEvent.PROPERTY, listenProperty);
            }

            //订阅mqtt消息的属性上报尝试获取固件包版本
            this.mqttSend?.listen(DeviceEvent.PROPERTY, true, {
              cacheTopic: clear,
              message: listenProperty,
            });

            const reconnect = async () => {
              if (this.deviceProtocol.config) {
                this.deviceProtocol.config.blue.mac = undefined;
              }

              await this.deviceProtocol.connect({timeout: 30, config: this.deviceProtocol.config});

              //连接成功后, 只等30s的升级回复
              timeoutIndex = setTimeout(() => {
                throw WebError.code(deviceError.UPGRADE_WAIT_SUCCESS_TIMEOUT);
              }, 30000);

              return data;
            }

            if (this.deviceProtocol.connected) {
              this.send.listen(DeviceEvent.DISCONNECTED, {
                cacheTopic: clearBle,
                message: async () => {
                  reconnect().then(resolve).catch(reject)
                }
              })
            } else {
              reconnect().then(resolve).catch(reject)
            }
          }).then(() => {
            progress.step = 3
            progress.progress = 100
            progress.desc = '升级成功'

            this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: 3, progress: 100});
            this._firmwareUpdateSend({version: data.edition});
          }).finally(() => {
            clearFn?.call(this);
          });
        }
      }
    }
  }

  async _onFingerprint(type, position, auth, staffId) {
    let buffer = "";
    const clear = {};
    await this.send.listen(this.deviceProtocol.serviceName.FINGERPRINTTYPE, {
      cacheTopic: clear,
      message: (data) => {
        if (data.success) {
          this.deviceProtocol.emit(DeviceEvent.FINGERPRINT_TYPE, {step: 3, type, position, auth, data, staffId});
        } else {
          this.deviceProtocol.emit(DeviceEvent.FINGERPRINT_TYPE, {
            step: -1,
            type,
            position,
            auth,
            data,
            staffId,
            error: this.deviceProtocol.exception({data})
          });
        }
        // const step = parseInt(params[3]);
      }
    })

    await this.send.listen(this.deviceProtocol.serviceName.FINGERPRINTVERIFY, {
      cacheTopic: clear, message: (data) => {
        this.deviceProtocol.emit(DeviceEvent.FINGERPRINT_VERIFY, {
          code: data.code,
          success: data.success,
          params: {
            position: data.params[1],
            status: data.params[2]
          }
        });
      }
    });
    await this.send.listen(this.deviceProtocol.serviceName.FINGERPRINTEND, {
      cacheTopic: clear,
      message: ({params}) => {
        if (params[0] === "OK") {
          const feature = params[3];
          const totalSize = parseInt(params[1]);
          const pageIndex = parseInt(params[2]);

          buffer += feature;

          if (pageIndex === totalSize) {
            this._fingerprintFinishSend({type, position, auth, buffer, staffId}).then((data) => {
              this.deviceProtocol.emit(DeviceEvent.FINGERPRINT_FINISH, data);
            }).finally(() => {
              this.send.unsubscribe(clear);
            })
          }
        }
      }
    })
    await this.send.listen("FIGSTEP", {
      cacheTopic: clear,
      message: ({params}) => {
        const step = parseInt(params[1]);
        this.deviceProtocol.emit(DeviceEvent.FINGERPRINT_TYPE, {step, type, position, auth});
      }
    })

    return {
      cancel: () => {
        this.send.unsubscribe(clear);
        return this.send.cancelOperation({type: 3});
      }
    }
  }

  async _changeSeal({sealId, sealName, motion, type, success, complete, message, fail, timeout} = {}) {
    return this.send.service(this.deviceProtocol.serviceName.START_REPLACE, [sealId, sealName, motion, type], {
      success, complete, message, fail, timeout
    });
  }

  async _changeSealFinish({sealId, sealName, motion, type, success, complete, message, fail, timeout} = {}) {
    return this.send.service(this.deviceProtocol.serviceName.END_REPLACE, [sealId, sealName, motion, type], {
      success, complete, message, fail, timeout
    }).then(async data => {
      await this._changeSealFinishSend({
        sealId, sealName, motion, status: 1
      });
      return data;
    });
  }

  async _wifiSetting({type, save, ssid, password, success, complete, message, fail, timeout}) {
    let list = []
    type === 2 ? list = [type, ssid, password] : list = [type, save, ssid, password]
    return this.send.service(this.deviceProtocol.serviceName.WIFI_SETTING, list, {
      success, complete, message, fail, timeout
    }).then(data => {
      return {
        status: parseInt(data.params[1]),
        message: data.params[2]
      }
    });
  }

  async _envChange({api, iot, type, clear, success, complete, message, fail, timeout} = {}) {
    return this.send.service(this.deviceProtocol.serviceName.ENV_CHANGE, [api, iot, type, clear], {
      success, complete, message, fail, timeout
    });
  }

  async _connectChange({usbMode, success, complete, message, fail, timeout} = {}) {
    if (+this.deviceProtocol.version < 7) {
      throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT, {
        msg: "当前版本不支持通信设置, 请升级固件"
      })
    }
    return this.send.service(this.deviceProtocol.serviceName.CONNECT_CHANGE, [usbMode], {
      success, complete, message, fail, timeout
    });
  }
}


class BleV2Codec extends BleCodec {

  static codec = new BleV2Codec();
  static resultCode = ["OK", "NG", "FAIL"]

  encode(action, params, {reply = false, errorCode}) {
    let msg;
    if (!reply) {
      if (action === "UPGRADEPACKETV2") {
        return params[0];
      } else {
        const data = `|${action}|${(params && params.length > 0 ? params.join("~") : "~")}|`;
        msg = `/>|${data.length + 3 + data.length.toString().length}${data}`;
      }
    } else {
      let code = 0;
      let codeMsg = "OK"

      if (errorCode) {
        code = errorCode.code;
        codeMsg = "FAIL";
      }

      const data = `|${action}|${codeMsg}~${code}|${(params && params.length > 0 ? params.join("~") : "~")}|`;
      msg = `/>|${data.length + 3 + data.length.toString().length}${data}`;
    }

    // 判断是否超过30个字节,不足时在末尾补0, 兼容aplus老款设备蓝牙
    if (msg.length < 36) {
      msg = msg.padEnd(36, '0') + "|";
    }

    msg += "#"
    return Buffer.from(msg);
  }

  decode(data) {
    const tmp = data.split("|");

    if (tmp.length >= 6 || tmp[tmp.length - 1] !== "#") {
      const msg = tmp[3].split("~");
      const params = tmp[4].split("~");
      params.unshift(msg[0]);

      return {
        success: !!msg[0] && msg[0] !== "NG" && msg[0] !== "FAIL",
        action: tmp[2],
        params: params,
        payload: data,
        code: parseInt(msg[1]),
        reply: true
      };
    } else {
      if (tmp.length > 4) {
        const params = tmp[3].split("~");
        let success = true;
        let code = 0;

        if (params[0] && BleV2Codec.resultCode.includes(params[0])) {
          success = params[0] === "OK";
          code = params[1] ? parseInt(params[1]) : 10000;
        } else {
          params.unshift("OK");
        }

        return {
          success: success,
          action: tmp[2],
          params: params,
          payload: data,
          code: code,
          reply: false
        };
      } else {
        return {
          success: true,
          action: tmp[2],
          params: ["ok"],
          payload: data,
          reply: false
        };
      }

    }
  }
}

export {
  BleV2Codec,
  BleV2DeviceProtocol,
  BleV2DeviceProtocolBeginSeal,
  BleV2DeviceProtocolOperation,
  BleSendV2
}